import {
  primaryColors,
  whiteShades
} from '@/assets/styles/helpers/colors.styles'

export const checkboxStyles = {
  '&.MuiCheckbox-root': {
    padding: 0,
    color: primaryColors.white,
    '&.Mui-checked': {
      color: primaryColors.white
    },
    '&.Mui-disabled': {
      color: whiteShades.shade1,
      cursor: 'default'
    }
  }
}
